import * as React from 'react';
import { EMPTY_TEXT, Modal, WhiteLabelMobileSpeechBox } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { WARNING_TEMPLATE_MODAL_SAVE_BUTTON_ID, WARNING_TEMPLATE_MODAL_STAY_HERE_BUTTON_ID } from "../../brandedNotification";
import { ConnectedRepairResourceLookup } from "../../resourcesLookup";
import { PhotoCaptureResourceLookupConstants, PhotoCaptureConstants, CONFIRMATION_MODAL_TITLE } from '../constants';
import { PhotoCapture } from '../enums';
import { getSourceNameByAssignmentTypeAndSubType } from '../utilities';
import { StyledShopAddress, StyledRepairContent, StyledDescription, StyledInnerDescription, StyledDivAvatarSpechBoxLayout } from './RepairSelectShopComponent.style';
import { ContentSectionGridWrapper, TemplateContainerGridWrapper } from './PhotoCaptureDamagePanelComponent.style';
import { IntelligentPBEContainerComponent } from './intelligentComponents';
export const RepairSelectShopComponent = ({ countryCode, companyCode, appTheme, resourceDetails, photoCaptureAttachmentInfo, evaluationDocId, isTermsAndConditionAccepted, contextId, assignmentType, assignmentSubType, fraudWarningAccept, photoCaptureUpdateContextDataAction, photoCapturePhotoUploadAction, photoCaptureShopSelectionScreenVisitedAction }) => {
    // Create the object only if resourceDetails exists
    const assignedBodyShopDetails = resourceDetails
        ? {
            coCd: countryCode,
            orgName: companyCode,
            resourceName: `${resourceDetails.firstName} ${resourceDetails.lastName}`,
            addressLine1: resourceDetails.addressLine || EMPTY_TEXT,
            addressLine2: EMPTY_TEXT,
            countryName: resourceDetails.countryCode || EMPTY_TEXT,
            city: resourceDetails.city || EMPTY_TEXT,
            state: resourceDetails.stateOrProvince || EMPTY_TEXT,
            crossoverCoCd: EMPTY_TEXT,
            crossoverOrgCd: EMPTY_TEXT,
            crossoverOrgUserId: EMPTY_TEXT,
            distance: EMPTY_TEXT,
            emailAddress: EMPTY_TEXT,
            geoX: EMPTY_TEXT,
            geoY: EMPTY_TEXT,
            orgCd: resourceDetails.resourceId || EMPTY_TEXT,
            orgId: EMPTY_TEXT,
            phoneNumber: EMPTY_TEXT,
            phoneNumber2: EMPTY_TEXT,
            phoneNumberExt: EMPTY_TEXT,
            phoneNumberExt2: EMPTY_TEXT,
            postalCd: resourceDetails.postalCode || EMPTY_TEXT,
            regionCd: EMPTY_TEXT
        }
        : undefined;
    const repairResourcePayload = {
        companyCode,
        countryCode,
        userType: PhotoCaptureResourceLookupConstants.USER_TYPE,
        searchBy: PhotoCaptureResourceLookupConstants.SEARCH_BY,
        radius: PhotoCaptureResourceLookupConstants.RADIUS,
        sortField: PhotoCaptureResourceLookupConstants.SORT_FIELD
    };
    const sourceName = getSourceNameByAssignmentTypeAndSubType(assignmentType, assignmentSubType);
    const [selectedResourceId, setSelectedResourceId] = React.useState(EMPTY_TEXT);
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isVisible, setIsVisible] = React.useState(false);
    const translateFn = TranslationService.translate;
    React.useEffect(() => {
        setIsModalOpen(prev => !prev);
    }, []);
    const onResourceItemClicked = React.useCallback((resourceId) => {
        setSelectedResourceId(resourceId);
    }, []);
    const onFinish = () => {
        photoCapturePhotoUploadAction(contextId, companyCode, sourceName);
    };
    const onProceed = () => {
        setIsModalOpen(prev => !prev);
        setIsVisible(true);
        photoCaptureShopSelectionScreenVisitedAction(true);
    };
    const saveButton = {
        id: `${PhotoCapture.PHOTO_CAPTURE}_${WARNING_TEMPLATE_MODAL_SAVE_BUTTON_ID}`,
        isBusy: false,
        label: `${translateFn(PhotoCaptureConstants.PROCEED_BUTTON)}`,
        onClick: onProceed
    };
    const stayHereButton = {
        id: `${PhotoCapture.PHOTO_CAPTURE}_${WARNING_TEMPLATE_MODAL_STAY_HERE_BUTTON_ID}`,
        isBusy: false,
        label: `${translateFn(PhotoCaptureConstants.FINISH)}`,
        onClick: onFinish
    };
    const onSubmitButtonClick = () => {
        if (selectedResourceId) {
            const contextDataUpdateInput = {
                attachmentInfo: photoCaptureAttachmentInfo,
                documentId: evaluationDocId,
                fraudWarningAccept: `${fraudWarningAccept}`,
                isTermsAndConditionAccepted: isTermsAndConditionAccepted ? PhotoCaptureConstants.Y : PhotoCaptureConstants.N,
                status: null,
                vehicle: null
            };
            photoCaptureUpdateContextDataAction(contextDataUpdateInput, contextId, companyCode, selectedResourceId, true);
        }
        photoCapturePhotoUploadAction(contextId, companyCode, sourceName);
    };
    return (React.createElement(IntelligentPBEContainerComponent, { islanguageHide: true, appTheme: appTheme, isFooter: true, hasMultipleButton: false, btnLabel: TranslationService.translate(PhotoCaptureConstants.SUBMIT), moveNext: onSubmitButtonClick },
        React.createElement(StyledRepairContent, null,
            React.createElement(StyledDivAvatarSpechBoxLayout, null,
                React.createElement(WhiteLabelMobileSpeechBox, { speechBoxRichText: appTheme.selectShopLandingMessage || PhotoCaptureConstants.SELECT_SHOP_LANDING_MESSAGE, speechBoxBackgroundColor: appTheme.selectedButtonBackgroundColor })),
            isModalOpen && (React.createElement(Modal, { isOpen: isModalOpen, title: translateFn(CONFIRMATION_MODAL_TITLE.HEADING_TITLE), isLightbox: false, maxWidth: "sm", primaryBtn: saveButton, tertiaryBtn: stayHereButton, shouldHideScroll: true, onClose: onFinish, id: `${PhotoCapture.PHOTO_CAPTURE}_modal` },
                React.createElement(TemplateContainerGridWrapper, { container: true },
                    React.createElement(ContentSectionGridWrapper, { item: true, xs: 10, className: "confirmation-modal-description" },
                        React.createElement(StyledDescription, null, translateFn(CONFIRMATION_MODAL_TITLE.SELECT_SHOP_DESCRIPTION_FIRST)),
                        resourceDetails && (React.createElement(StyledShopAddress, { id: "resourceDetails_context" },
                            React.createElement("p", null,
                                translateFn(PhotoCaptureConstants.SHOP_NAME),
                                ":",
                                React.createElement("span", null,
                                    resourceDetails.firstName,
                                    resourceDetails.lastName)),
                            React.createElement("p", null,
                                translateFn(PhotoCaptureConstants.ADDRESS),
                                ":",
                                React.createElement("span", null,
                                    resourceDetails.addressLine,
                                    ",",
                                    resourceDetails.city,
                                    ",",
                                    resourceDetails.stateOrProvince,
                                    ",",
                                    resourceDetails.postalCode,
                                    ",",
                                    resourceDetails.countryCode)))),
                        React.createElement(StyledInnerDescription, null, translateFn(CONFIRMATION_MODAL_TITLE.SELECT_SHOP_DESCRIPTION_SECOND))),
                    React.createElement(ContentSectionGridWrapper, { item: true, xs: 10, className: "confirmation-modal-description" })))),
            isVisible && (React.createElement(ConnectedRepairResourceLookup, { repairResourceLookupPayload: repairResourcePayload, selectedResourceId: selectedResourceId, onResourceItemClicked: onResourceItemClicked, selectedButtonBackgroundColor: appTheme.selectedButtonBackgroundColor, assignedBodyShopDetails: assignedBodyShopDetails, noShopsFoundMessage: PhotoCaptureConstants.NO_RECORD_FOUND })))));
};
//# sourceMappingURL=RepairSelectShopComponent.js.map